/**
 * @Description: 素材列表路由
 * @author zhaijiayu
 * @date 2021/8/17
*/

import MaterialList from '../../../pages/material';
import MaterialEdit from '../../../pages/material/add'
import MaterialDetail from '../../../pages/material/detail'
const list = [
    {
        path: '/material/:myset',
        component: MaterialList,
        name: 'material'
    },
]
export default list